import script from "./AvailableOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./AvailableOptions.vue?vue&type=script&setup=true&lang=js"

import "./AvailableOptions.vue?vue&type=style&index=0&id=3c1c001c&lang=scss&scoped=true"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c1c001c"]])

export default __exports__